export class AdminTimeEventEmitterBo {
    isCreate: boolean = false;
    isClose: boolean = false;
    getListDetails: GetAdminTimeBO = new GetAdminTimeBO();
    EmployeeDropDown: any = [];
    EditEntryTypeList:any=[];
  }
  
  export class GetAdminTimeBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    date: string;
    totalhours: number;
    startDate: string;
    endDate: string;
    inTime: string;
    outTime: string;
    employeeId:string = "00000000-0000-0000-0000-000000000000";
    agencyId:string = "00000000-0000-0000-0000-000000000000";
    status: number;
    orderColumn: string = "employeeName";
    orderType: string = "ASC";
    matchCase: boolean = false;
    operator: string = "startswith";
    field: string = "employeeName";
    value: string="";
    currentpage: number = 1;
    pageitems: number = 10;
    type: string = "string";
    errortype: string;
  }
  
  export class SaveAdminTimeNonBillable {
    id: string = "00000000-0000-0000-0000-000000000000";
    employeeId: string = "00000000-0000-0000-0000-000000000000";
    agencyId: string = "00000000-0000-0000-0000-000000000000";
    date: string;
    inTime: string;
    outTime: string;
    notes: string;
    totalhours: number;
    entryTypeLid:any;
  }
  
  export class DeleteAdminTimeBO {
    password: string = "";
    adminTime_id: string = "00000000-0000-0000-0000-000000000000";
  }
  